//#region IMPORT
import React, { useEffect, useRef } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { Button as GridButton, Dialog } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import {
  CloudUpload as CloudUploadIcon,
  ConnectedTvOutlined,
  DriveFolderUpload as FileUploadIcon,
  Download as DownloadIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BusinessIcon from '@mui/icons-material/Business';
import ApartmentIcon from '@mui/icons-material/Apartment';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DomainIcon from '@mui/icons-material/Domain';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';
import GridCellFileUpload from '../../../../Components/Ui/GridCellFileUpload/GridCellFileUpload';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  Buttonk,
  Checkbox,
  FormControlLabel,
  Button,
  Chip,
} from '@mui/material';

function TRA_BASIC_02(props) {
  const gridRef1 = useRef(); // 교육현황

  const buttonStyle = {
    height: 44,
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    bgcolor: '#7e57c2',
    color: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#5e35b1',
      transform: 'scale(1.05)',
    },
  };

  const columnDefs1 = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 80,
      cellStyle: { textAlign: 'right' },
      editable: false,
    },
    {
      field: 'DEP_NM1',
      headerName: '본부',
      width: 150,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM2',
      headerName: '부서',
      width: 150,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM3',
      headerName: '팀',
      width: 150,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM4',
      headerName: '파트',
      width: 150,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'EDU_FILE_NAME',
      headerName: '교육자료 파일명',
      minWidth: 200,
      editable: false,
      flex: 1,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'VIDEO_FILE_NAME',
      headerName: '교육동영상 파일명',
      width: 200,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },

    {
      field: 'upload',
      headerName: '파일 업로드',
      pinned: 'right',
      width: 120,
      editable: false,
      cellRenderer: (e) => {
        return (
          <GridButton
            startIcon={<CloudUploadIcon />}
            size="small"
            variant="contained"
            name={'업로드'}
            sx={{
              width: '100%',
              backgroundColor: '#2196f3',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#1976d2',
              },
            }}
            onClick={() => {
              props.PopupClickEvent1(e.data);
            }}
          />
        );
      },
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'download',
      headerName: '교육자료',
      pinned: 'right',
      width: 120,
      editable: false,
      cellRenderer: (e) => {
        return (
          <GridButton
            size="small"
            name={'다운로드'}
            sx={{ width: '100%' }}
            onClick={() => {
              props.DownloadLogic1(e.data);
            }}
          />
        );
      },
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'download',
      headerName: '교육동영상',
      pinned: 'right',
      width: 120,
      editable: false,
      cellRenderer: (e) => {
        return (
          <GridButton
            size="small"
            name={'다운로드'}
            sx={{ width: '100%' }}
            onClick={() => {
              props.DownloadLogic2(e.data);
            }}
          />
        );
      },
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'CREATE_ID',
      headerName: '작성자',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'mapBlob',
      headerName: '블롭',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'mapFile',
      headerName: '파일',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'mapFileName',
      headerName: '파일명(사용자가 올린 이름)',
      minWidth: 150,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'SAVE_NAME',
      headerName: '파일명(저장되는 이름)',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'PREVIEW_FILE_PATH',
      headerName: '미리보기 주소',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
  ];

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick4) {
      if (!props.validateSelection()) {
        props.setFilterClick4(false);
        return;
      }

      gridRef1.current.api.setQuickFilter(props.searchRef.current.searchText);
      props.setFilterClick4(false);
    }
    if (props.searchClick4) {
      props.ResetLogicAll();
      if (!props.validateSelection()) {
        props.setSearchClick4(false);
        return;
      }

      props.SearchLogic1(
        props.searchRef.current.custCd,
        props.searchRef.current.searchYear
      );
      props.setSearchClick4(false);
    }
    if (props.addClick4) {
      if (!props.validateSelection()) {
        props.setAddClick4(false);
        return;
      }

      GridFunctions.addClick(gridRef1);
      props.setAddClick4(false);
    }
    if (props.saveClick4) {
      if (!props.validateSelection()) {
        props.setSaveClick4(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick4(false);
    }
    if (props.deleteClick4) {
      if (!props.validateSelection()) {
        props.setDeleteClick4(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick4(false);
    }
    if (props.printClick4) {
      if (!props.validateSelection()) {
        props.setPrintClick4(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick4(false);
    }
  }, [
    props.filterClick4,
    props.searchClick4,
    props.addClick4,
    props.saveClick4,
    props.deleteClick4,
    props.printClick4,
  ]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        gridRef={gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        flex={1}
        title1="교육자료 등록 정보"
        addYn1="Y"
        printYn1="N"
        deleteYn1="N"
        addClick1={(e) => {
          if (!props.validateSelection()) return;

          props.PopupClickEvent2();
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1(
            props.searchRef.current.custCd,
            props.searchRef.current.searchYear
          );
        }}
      />
      {props.modalToggle1 && (
        <Dialog
          title={'교육 자료 업로드'}
          open={props.modalToggle1}
          onClose={() => {
            props.setModalToggle1(false);
            props.SearchLogic1?.();
          }}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '100vh',
              width: '70vw',
              bgcolor: '#f9fafb',
              p: 3,
            },
          }}
          useSaveAfterClose={true}
          closeButtonName="닫기"
          content={
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                height: '100%',
              }}
            >
              {/* 왼쪽: 동영상 업로드 */}
              <Paper
                elevation={4}
                sx={{
                  width: '50%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  bgcolor: '#ffffff',
                  boxShadow: '0 4px 12px rgba(33, 150, 243, 0.1)',
                  overflow: 'hidden',
                }}
              >
                <Typography
                  variant="h6"
                  mb={2}
                  sx={{ fontWeight: 'bold', color: '#1976d2' }}
                >
                  📹 교육 동영상 업로드
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mb: 2 }}
                >
                  <Button variant="contained" component="label" color="primary">
                    동영상 선택
                    <input
                      type="file"
                      hidden
                      accept="video/*"
                      onChange={props.handleVideoChange}
                    />
                  </Button>
                  <TextField
                    size="small"
                    value={props.videoFile?.name || props.videoFileName || ''}
                    placeholder="선택된 파일 없음"
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{ width: 320 }}
                  />

                  <IconButton
                    onClick={(e) => {
                      props.handleVideoDelete(e.data);
                    }}
                    disabled={!props.videoFile && !props.videoFileName}
                    sx={{
                      color: 'red',
                      backgroundColor: '#f0f0f0',
                      '&:hover': { backgroundColor: '#e0e0e0' },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>

                <Box
                  sx={{
                    flexGrow: 1,
                    borderRadius: 2,
                    border: '2px dashed #1976d2',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: '#e3f2fd',
                    overflow: 'hidden',
                    minHeight: 500,
                  }}
                >
                  {props.videoFile ? (
                    // 로컬에 선택한 파일이 있을 때 (새로 업로드된 상태)
                    <video
                      controls
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        borderRadius: 8,
                      }}
                      src={URL.createObjectURL(props.videoFile)}
                      key={props.videoFile.name} // 새 파일 변경 시 강제 리렌더링용
                    />
                  ) : props.videoUrl ? (
                    // 서버에 저장된 URL이 있을 때
                    <video
                      controls
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        borderRadius: 8,
                      }}
                      src={props.videoUrl}
                      onError={(e) => console.error('❌ Video Load Error', e)}
                    >
                      <source src={props.videoUrl} type="video/mp4" />
                      브라우저가 video 태그를 지원하지 않습니다.
                    </video>
                  ) : (
                    // 둘 다 없을 때
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: 'center', px: 2 }}
                    >
                      동영상 썸네일 미리보기 영역
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* 오른쪽: 교육 자료 업로드 */}
              <Paper
                elevation={4}
                sx={{
                  width: '50%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  bgcolor: '#ffffff',
                  boxShadow: '0 4px 12px rgba(156, 39, 176, 0.1)',
                  overflow: 'hidden',
                }}
              >
                <Typography
                  variant="h6"
                  mb={2}
                  sx={{ fontWeight: 'bold', color: '#9c27b0' }}
                >
                  📄 교육 자료 업로드
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mb: 2 }}
                >
                  <Button
                    variant="contained"
                    component="label"
                    color="secondary"
                    sx={{ mb: 2, alignSelf: 'flex-start' }}
                  >
                    자료 선택
                    <input
                      type="file"
                      hidden
                      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.png,.jpg,.jpeg,.hwp"
                      onChange={props.handleEduFileChange}
                    />
                  </Button>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="교육 자료 파일명"
                    value={props.previewFileName || ''}
                    inputProps={{
                      readOnly: true,
                      tabIndex: -1,
                      style: { caretColor: 'transparent' },
                    }}
                    sx={{ width: 320 }}
                  />

                  <IconButton
                    onClick={props.handleEduFileDelete}
                    disabled={!props.previewFileName}
                    sx={{
                      color: 'red',
                      backgroundColor: '#f0f0f0',
                      '&:hover': { backgroundColor: '#e0e0e0' },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>

                <Box
                  sx={{
                    border: '1px dashed #ccc',
                    borderRadius: 1,
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    overflow: 'auto', // 💡 오버플로우 스크롤 허용
                    minHeight: '600px', // 💡 최소 높이 확보
                  }}
                >
                  {props.renderPreview
                    ? props.renderPreview()
                    : '미리보기 영역'}
                </Box>
              </Paper>
            </Box>
          }
        />
      )}

      {props.modalToggle3 && (
        <Dialog
          title={'교육 자료 업로드'}
          open={props.modalToggle3}
          onClose={() => {
            props.setModalToggle3(false);
          }}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '100vh',
              width: '70vw',
              bgcolor: '#f9fafb',
              p: 2,
            },
          }}
          useSaveAfterClose={true}
          closeButtonName="닫기"
          content={
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                height: '100%',
                position: 'relative', // 버튼 위치 조정용
              }}
            >
              {/* 왼쪽: 동영상 업로드 */}
              <Paper
                elevation={4}
                sx={{
                  width: '50%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  bgcolor: '#ffffff',
                  boxShadow: '0 4px 12px rgba(33, 150, 243, 0.1)',
                  overflow: 'hidden',
                }}
              >
                <Typography
                  variant="h6"
                  mb={2}
                  sx={{ fontWeight: 'bold', color: '#1976d2' }}
                >
                  📹 교육 동영상 업로드
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mb: 2 }}
                >
                  <Button variant="contained" component="label" color="primary">
                    동영상 선택
                    <input
                      type="file"
                      hidden
                      accept="video/*"
                      onChange={props.handleVideoChange2}
                    />
                  </Button>
                  <TextField
                    size="small"
                    value={props.videoFile?.name || ''}
                    placeholder="선택된 파일 없음"
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{ width: 320 }}
                  />

                  <IconButton
                    onClick={(e) => {
                      props.handleVideoDelete2(e.data);
                    }}
                    //onClick={props.handleVideoDelete}
                    disabled={!props.videoFile}
                    sx={{
                      color: 'red',
                      backgroundColor: '#f0f0f0',
                      '&:hover': { backgroundColor: '#e0e0e0' },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>

                <Box
                  sx={{
                    flexGrow: 1,
                    borderRadius: 2,
                    border: '2px dashed #1976d2',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: '#e3f2fd',
                    overflow: 'hidden',
                    minHeight: 500,
                  }}
                >
                  {props.videoFile ? (
                    // 로컬에 선택한 파일이 있을 때 (새로 업로드된 상태)
                    <video
                      controls
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        borderRadius: 8,
                      }}
                      src={URL.createObjectURL(props.videoFile)}
                      key={props.videoFile.name} // 새 파일 변경 시 강제 리렌더링용
                    />
                  ) : props.videoUrl ? (
                    // 서버에 저장된 URL이 있을 때
                    <video
                      controls
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        borderRadius: 8,
                      }}
                      src={props.videoUrl}
                      key={props.videoUrl} // URL 변경 시 강제 리렌더링용
                    />
                  ) : (
                    // 둘 다 없을 때
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: 'center', px: 2 }}
                    >
                      동영상 썸네일 미리보기 영역
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* 오른쪽: 교육 자료 업로드 */}
              <Paper
                elevation={4}
                sx={{
                  width: '50%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  bgcolor: '#ffffff',
                  boxShadow: '0 4px 12px rgba(156, 39, 176, 0.1)',
                  overflow: 'hidden',
                }}
              >
                {/* 제목 + 버튼을 같은 줄에 배치 */}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', color: '#9c27b0' }}
                  >
                    📄 교육 자료 업로드
                  </Typography>

                  {/* 부서선택하러가기 버튼 */}
                  <Button
                    variant="contained"
                    startIcon={<DomainIcon />}
                    sx={{
                      ...buttonStyle,
                      ml: 2,
                    }}
                    onClick={() => {
                      // 둘 다 없는 경우에만 경고창
                      if (!props.videoFile && !props.eduFile) {
                        props.dispatch(
                          props.showSnackbar({
                            message:
                              '교육 동영상 또는 교육 자료 중 하나 이상을 업로드해주세요.',
                            type: 'warning',
                          })
                        );
                        return;
                      }

                      props.setSelectedBonbu([]);
                      props.setSelectedBuseo([]);
                      props.setSelectedTeam([]);
                      props.setSelectedPart([]);

                      props.setModalToggle3(false);
                      props.setModalToggle2(true);
                      props.fetchDepartmentData?.();
                    }}
                  >
                    부서선택하러가기
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mb: 2 }}
                >
                  <Button
                    variant="contained"
                    component="label"
                    color="secondary"
                    sx={{ mb: 2, alignSelf: 'flex-start' }}
                  >
                    자료 선택
                    <input
                      type="file"
                      hidden
                      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.png,.jpg,.jpeg,.hwp"
                      onChange={props.handleEduFileChange2}
                    />
                  </Button>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="교육 자료 파일명"
                    value={props.previewFileName || ''}
                    inputProps={{
                      readOnly: true,
                      tabIndex: -1,
                      style: { caretColor: 'transparent' },
                    }}
                    sx={{ width: 320 }}
                  />

                  <IconButton
                    onClick={props.handleEduFileDelete2}
                    disabled={!props.previewFileName}
                    sx={{
                      color: 'red',
                      backgroundColor: '#f0f0f0',
                      '&:hover': { backgroundColor: '#e0e0e0' },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>

                <Box
                  sx={{
                    border: '1px dashed #ccc',
                    borderRadius: 1,
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'auto', // 💡 오버플로우 스크롤 허용
                    minHeight: '600px', // 💡 최소 높이 확보
                  }}
                >
                  {props.renderPreview
                    ? props.renderPreview()
                    : '미리보기 영역'}
                </Box>
              </Paper>
            </Box>
          }
        />
      )}

      {props.modalToggle2 && (
        <Dialog
          title="교육 자료 업로드 & 대상 부서 선택"
          open={props.modalToggle2}
          onClose={() => {
            props.setModalToggle2(false);
            //props.SearchLogic1?.();
          }}
          maxWidth="xl"
          fullWidth
          saveButtonName={'저장'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.handleSave();
          }}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '100vh',
              width: '70vw',
              bgcolor: '#f9fafb',
              p: 2,
            },
          }}
          content={
            <Box
              sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
            >
              <Box
                sx={{
                  mb: 1,
                  p: 1,
                  borderRadius: 2,
                  bgcolor: '#e0f2f1', // 연한 청록색 배경
                  border: '1px solid #b2dfdb',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<UploadFileIcon />}
                  onClick={() => {
                    props.setModalToggle2(false);
                    props.setModalToggle3(true);
                  }}
                  sx={{
                    ...buttonStyle,
                    mr: 2,
                  }}
                >
                  교육자료등록하러가기
                </Button>

                <InfoOutlinedIcon color="primary" />
                <Typography variant="body1" color="text.primary">
                  교육 자료를 등록할 대상을 선택해주세요
                </Typography>
              </Box>

              {/* 4단 선택 박스 */}
              <Box sx={{ display: 'flex', gap: 3, flexGrow: 1 }}>
                {/* 본부 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#d8eefdff',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <BusinessIcon sx={{ mr: 1, color: '#1976d2' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#1976d2' }}
                    >
                      본부
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.bonbuList,
                    props.selectedBonbu,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedBonbu,
                        props.setSelectedBonbu
                      )
                  )}
                </Paper>

                {/* 부서 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#f3e5f5',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <ApartmentIcon sx={{ mr: 1, color: '#8e24aa' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#8e24aa' }}
                    >
                      부서
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.buseoList,
                    props.selectedBuseo,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedBuseo,
                        props.setSelectedBuseo
                      )
                  )}
                </Paper>

                {/* 팀 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#e4f3d4ff',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <GroupIcon sx={{ mr: 1, color: '#558b2f' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#558b2f' }}
                    >
                      팀
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.teamList,
                    props.selectedTeam,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedTeam,
                        props.setSelectedTeam
                      )
                  )}
                </Paper>

                {/* 파트 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#fff3e0',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <CategoryIcon sx={{ mr: 1, color: '#ef6c00' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#ef6c00' }}
                    >
                      파트
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.partList,
                    props.selectedPart,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedPart,
                        props.setSelectedPart
                      )
                  )}
                </Paper>
              </Box>

              {/* 최종 선택 Chip 표시 영역 */}

              <Box
                sx={{
                  mt: 4,
                  p: 2,
                  border: '1px solid #90caf9',
                  borderRadius: 2,
                  bgcolor: '#f5f5f5',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}
                >
                  <AssignmentTurnedInIcon sx={{ mr: 1 }} />
                  등록 대상 목록
                </Typography>

                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {props.getFilteredSelectedItems().map((item, idx) => (
                    <Chip
                      key={idx}
                      label={`${item} (${props.getDepLevel(item)})`}
                      onDelete={() => {
                        if (props.selectedBonbu.includes(item)) {
                          props.setSelectedBonbu((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        } else if (props.selectedBuseo.includes(item)) {
                          props.setSelectedBuseo((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        } else if (props.selectedTeam.includes(item)) {
                          props.setSelectedTeam((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        } else if (props.selectedPart.includes(item)) {
                          props.setSelectedPart((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        }
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            </Box>
          }
        />
      )}
    </React.Fragment>
  );
}

export default TRA_BASIC_02;
